module.exports = __webpack_public_path__ + "img/CH01-016-017.0f806710.jpg";